<template>
  <div class="results">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${headerBackgroundImageUrl})`">
      </div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div
        class="header-slider"
        :style="`background-image: url(${mobileHeaderBackgroundImageUrl})`"
      ></div>
    </div>

    <BackButton></BackButton>

    <div class="body text-left">
      <div class="boxed container">
        <div class="title">
          <h2>{{ categoryName }}</h2>
        </div>

        <div class="results-list">
          <div v-if="this.$store.state.searchResultsLoading === true" class="loading-container text-center">
            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
          </div>

          <div
            v-else-if="this.$store.state.searchResults.items.length === 0"
            class="content boxed card-like no-results">
            <div class="section message text-center">Oops... Parece que los negocios aún se están registrando en esta categoría.
              <br /><b>¡Regresa pronto!</b></div>

            <b-row align-h="center" class="register-link-container">
              <b-col class="register-link-section-left col-3 col-sm-2 d-none d-sm-block">
              </b-col>
              <router-link to="/registro" col class="col-12 col-sm-8 register-link-section-center">
                <div class="register-link text-center">
                  Si deseas registrar tu negocio o servicio, haz click aquí
                </div>

              </router-link>
              <b-col class="register-link-section-right col-sm-2 d-none d-sm-block">
              </b-col>
            </b-row>
          </div>

          <div v-else class="list">
            <ResultListItem
              v-for="(item, index) in this.$store.state.searchResults.items"
              v-bind:place="item"
              v-bind:index="index"
              v-bind:key="item.id"
              v-on:place-on-click="placeOnClick"
              >
            </ResultListItem>
          </div>
        </div>

      </div>
    </div>

    <div class="bottom-spacer"></div>
    <Footer></Footer>
  </div>
</template>


<script>
  // @ is an alias to /src
  // import ResultsHeader from "@/components/ResultsHeader.vue";
  import ResultListItem from "../components/ResultListItem";
  import Footer from "../components/Footer";
  import FloatingLogo from "../components/FloatingLogo";
  import BackButton from "../components/BackButton";

  export default {
    name: "Results",
    components: {
      BackButton,
      FloatingLogo,
      Footer,
      ResultListItem,
      // ResultsHeader
    },
    data() {
      return {
        headerBackgroundImageUrl: "",
        mobileHeaderBackgroundImageUrl: ""
      };
    },
    created () {
      this.routeChanged()
    },
    watch: {
      '$route.params.state': function (id) {
        this.routeChanged()
      },
      '$route.params.category': function (id) {
        this.routeChanged()
      },
      '$route.params.page': function (id) {
        this.routeChanged()
      },
    },
    computed: {
      categoryName: function() {
        const categorySlug = this.$route.params.categoryName
        const matches = this.$store.state.staticCategories.filter( item => item.slug == categorySlug )

        if (matches.length > 0)
          return matches[0].name
        else
          return ""
      }
    },
    methods: {
      fetchResults () {
        console.log("Fetching results...")
        this.$store.dispatch({
          type: "action",
          actionType: this.$types.DO_SEARCH,
          value: {
            state: this.$route.params.state,
            category: this.$route.params.category,
            page: this.$route.params.page | 1
          }
        });
      },
      placeOnClick(place) {
        console.log(`Parent:: User clicked on ${place.name}`)

        this.$router.push({
          name: "place",
          params: {
            state: this.$route.params.state,
            stateName: this.$route.params.stateName,
            place: place.id,
            placeName: place.name
          }
        });
      },
      routeChanged: function() {
        this.headerBackgroundImageUrl = "";

        const selectedStateArr = this.$store.state.staticStates.filter(
                stateObj => stateObj.value !== null ? stateObj.value.id == this.$route.params.state : false
        );

        if (selectedStateArr.length < 1) {
          console.log("array.length < 1")
          this.goHome();
          return;
        }

        const selectedState = selectedStateArr[0].value;

        if (this.$route.params.stateName !== selectedState.slug) {
          console.log("param and slug don't match", this.$route.params.stateName, selectedState.slug)
          this.goHome();
          return;
        }

        // Validate category

        const imageUrl = `${this.$constants.STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`
        const mobileImageUrl = `${this.$constants.MOBILE_STATES_HEADER_BASE_URL}${selectedState.slug}${this.$constants.STATES_HEADER_EXT}`

        // console.log(imageUrl);

        this.headerBackgroundImageUrl = imageUrl;
        this.mobileHeaderBackgroundImageUrl = mobileImageUrl;

        this.fetchResults();
      }

    }
  };
</script>
